<template>
    <b-popover
        v-if="activities.length > 0"
        :target="target"
        :placement="placement"
        triggers="click blur"
        :disabled.sync="disabled"
        id="treatmentActivityList"
        ref="treatmentActivityList"
        custom-class="treatment-activity-list"
        @show="onPopoverShow"
        @hide="onPopoverHide"
    >
        <ul class="list-group">
            <template v-if="updatedActivities.length > 0">
                <li
                    v-for="(activity, index) in updatedActivities"
                    :key="index"
                    class="list-group-item d-flex align-items-start"
                    href="#"
                    @click="openModal(activity)"
                >
                    <span class="font-weight-bold pr-1">{{
                        _setTimeDisplay(activity.dueCalculated.time, false)
                    }}</span>
                    <span class="font-weight-light text-hidden">{{
                        activity.activityText
                    }}</span>
                </li>
            </template>
            <span v-else>
                <div class="loading-skeleton mb-1"></div>
            </span>
        </ul>
    </b-popover>
</template>
<script>
import ScheduleHelper from "../helper";
import TreatmentActivityMixin from "@/mixins/treatment-activity-details";

export default {
    mixins: [ScheduleHelper, TreatmentActivityMixin],
    props: {
        treatment: {
            type: Object,
            default() {
                {
                    return {};
                }
            }
        },
        target: {
            type: String
        },
        activities: {
            type: Array,
            required: true
        },
        prepareDateTime: {
            type: Function
        },
        dialogs: {
            type: Object,
            default() {
                return {};
            }
        },
        placement: {
            type: String,
            default: "rightbottom"
        },
        disabled: {
            type: Boolean,
            default: false
        },
        parentRef: {
            type: HTMLDivElement,
            default() {
                return null;
            }
        },
        labelOptions: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            disableButton: false,
            activity: null,
            updatedActivities: []
        };
    },
    methods: {
        async updateActivities() {
            let updatedActivities = [];
            for (let i = 0; i < this.activities.length; i++) {
                let activity = this.activities[i];
                activity.activityText = this.getActivityText(activity);
                updatedActivities.push(activity);
            }
            this.updatedActivities = updatedActivities;
        },
        getActivityText(activity) {
            // Determine the activity text based on the treatment type
            let activityText = null;
            switch (activity.treatment_activity_type_id) {
                case this.TREATMENT_TYPE_STR.MEDICAL:
                    activityText = activity.medication;
                    activityText =
                        activityText.length > 0
                            ? activityText[0]?.item?.name ||
                              activityText[0].name
                            : null;
                    activityText = `Medical: ${activityText}`;
                    break;
                case this.TREATMENT_TYPE_STR.VITAL:
                    activityText = activity.vitals
                        .map(vital => vital.master_vital.vital)
                        .join(", ");
                    activityText = `Vital: ${activityText}`;
                    break;
                case this.TREATMENT_TYPE_STR.OTHER: {
                    let other = activity.other_task[0];
                    let labelId = other.label_id ? other.label_id : 1;
                    activityText = this.labelOptions.find(
                        option => option.value === labelId
                    );
                    let updatedActivityText = `Other: ${activityText.text}`;
                    if (activityText.text == "Miscellaneous") {
                        updatedActivityText = `Misc, ${
                            other.task == "" ? "No details" : other.task
                        }`;
                    }
                    activityText = updatedActivityText;
                    break;
                }
            }
            return activityText;
        },
        onPopoverShow() {
            // Attach the scroll listener to the referenced element
            this.parentRef.addEventListener("scroll", this.closePopover);
            this.updateActivities();
        },
        onPopoverHide() {
            // Remove the scroll listener from the referenced element
            this.parentRef.removeEventListener("scroll", this.closePopover);
        },
        async closePopover() {
            // Wait until the DOM updates and popover is fully rendered
            this.$refs.treatmentActivityList.$emit("close");
        }
    }
};
</script>
<style scoped>
.treatment-activity-list {
    z-index: 4;
}
.list-group {
    max-height: 300px;
    overflow-y: scroll;
}
.list-group-item {
    cursor: pointer;
    border: none !important;
    display: flex;
    align-items: center; /* Aligns the text vertically in the middle */
    white-space: nowrap; /* Prevents text wrapping */
    transition: background-color 0.3s ease; /* Smooth transition for background color */
}
.list-group-item:hover {
    background-color: #c9ccde; /* Light gray background on hover */
    border-radius: 4px; /* Optional: adds rounded corners on hover */
}
.loading-skeleton {
    background: #e0e0e0;
    background: linear-gradient(
        to right,
        rgba(230, 230, 230, 1) 8%,
        rgba(238, 238, 238, 1) 30%,
        rgba(230, 230, 230, 1) 33%
    );
    background-size: 200% 100%;
    width: 125px;
    height: 35px;
    border-radius: 3px;
    animation: loading 10s infinite linear; /* Smooth animation */
}
.text-hidden {
    overflow-x: hidden;
    text-overflow: ellipsis;
}
</style>
